import styles from './styles.module.scss'

const Title = ({
  Tag = 'h2',
  alignText = 'left',
  customClass,
  colorText,
  variant,
  children
}) => {
  return (
    <Tag
      className={`${styles.title} 
      ${styles[`title--${alignText}`]} 
      ${styles[`title--${colorText}`]} 
      ${styles[`title--${variant}`]}
      ${customClass}`}
    >
      {children}
    </Tag>
  )
}

export default Title
